/* @flow */

export const KEY_CODES = {
    ENTER: 13,
    SPACE: 32
};



// WEBPACK FOOTER //
// ./node_modules/belter/src/constants.js